import React from 'react';

export const ResponsiveContext = React.createContext(true);
